import React, { useState } from 'react';
import Sidebar from "../../components/sidebar/Sidebar";
import Header from "../../components/header/Header";
import "../../styles/sidebar/sidebar.css";
import "../../styles/dashboard/dashboard.css";
import AnalyticsChart from '../../components/analytics/AnalyticsChart';
import ScannedRecordsChart from '../../components/analytics/ScannedRecordsChart';

const CoordinatorAnalytics = () => {
  const [activeTab, setActiveTab] = useState("scanners");

  return (
    <div className="dashboard-container">
        <Sidebar role="coordinator" />
        <div className="main-content">
          <Header />
          <div className="dashboard-content coordinator">
            <div className="tabs">
              <div
                className={`tab ${activeTab === "scanners" ? "active" : ""}`}
                onClick={() => setActiveTab("scanners")}
              >
                Scanner Operators
              </div>
              <div
                className={`tab ${activeTab === "indexers" ? "active" : ""}`}
                onClick={() => setActiveTab("indexers")}
              >
                Indexers
              </div>
            </div>
            
            <div className="analytics-container">
              <div className="scanner-operators-chart">
                <div>
                  <AnalyticsChart activeTab={activeTab} />
                </div>
              </div>

              <div className="scanned-records-chart">
                <div>
                  <ScannedRecordsChart activeTab={activeTab} />
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default CoordinatorAnalytics;